import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function GentleReminders() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="19095" id="secure-your-future" className="dark bg-background bg-[radial-gradient(circle_at_center,_var(--primary)_/_0.15_0%,_transparent_70%)] text-foreground relative w-full overflow-hidden py-24 lg:py-32 flex flex-col items-center justify-center">
      {}
      <div className="absolute inset-0 z-0 opacity-10 pointer-events-none overflow-hidden">
        <div className="absolute bottom-0 left-0 w-[200%] h-full flex animate-wave">
          <svg className="w-1/2 h-full text-primary" viewBox="0 0 1440 320" preserveAspectRatio="none" fill="currentColor">
            <path fillOpacity="1" d="M0,160L48,176C96,192,192,224,288,224C384,224,480,192,576,165.3C672,139,768,117,864,128C960,139,1056,181,1152,197.3C1248,213,1344,203,1392,197.3L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
          </svg>
          <svg className="w-1/2 h-full text-primary" viewBox="0 0 1440 320" preserveAspectRatio="none" fill="currentColor">
            <path fillOpacity="1" d="M0,160L48,176C96,192,192,224,288,224C384,224,480,192,576,165.3C672,139,768,117,864,128C960,139,1056,181,1152,197.3C1248,213,1344,203,1392,197.3L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
          </svg>
        </div>
      </div>

      {}
      <div ref={ref} className={cn("relative z-10 container mx-auto px-6 text-center transition-all duration-1000 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <h2 className="text-4xl md:text-6xl lg:text-7xl font-serif font-bold tracking-tighter text-foreground mb-8 leading-tight">
          Design Your Legacy <br className="hidden md:block" />
          Today.
        </h2>
        
        <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-12 leading-relaxed">
          Unlock non-traditional wealth strategies and secure your future with bespoke financial solutions 
          crafted for your unique three-dimensional outlook on prosperity.
        </p>

        <Button asChild className="bg-primary hover:bg-primary/90 text-primary-foreground rounded-full px-10 py-8 text-lg shadow-xl shadow-primary/20 hover:shadow-2xl hover:shadow-primary/30 transition-all duration-300 hover:-translate-y-1">
          <Link to="/ContactPage">
            Begin Consultation
            <ArrowRight className="ml-2 h-5 w-5" />
          </Link>
        </Button>
      </div>

      <style jsx>{`
        @keyframes wave {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-wave {
          animation: wave 20s linear infinite;
        }
      `}</style>
    </section>;
}